import { render, staticRenderFns } from "./survey-and-design.vue?vue&type=template&id=43b5cc8c&scoped=true"
import script from "./survey-and-design.vue?vue&type=script&lang=js"
export * from "./survey-and-design.vue?vue&type=script&lang=js"
import style0 from "./survey-and-design.vue?vue&type=style&index=0&id=43b5cc8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5cc8c",
  null
  
)

export default component.exports